import { render, staticRenderFns } from "./bankDialog.vue?vue&type=template&id=60192229&"
import script from "./bankDialog.vue?vue&type=script&lang=js&"
export * from "./bankDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports